<div *ngIf="isVisible"
  class="w-full flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-semibold shadow-md">
  <!-- White Warning Icon -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-5 h-5" fill="white">
    <path
      d="M12 2c-.35 0-.7.18-.89.53L1.61 19.2c-.39.7.11 1.56.89 1.56h18.99c.78 0 1.28-.86.89-1.56L12.89 2.53A1 1 0 0 0 12 2zm0 6c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1zm0 10c-.83 0-1.5-.67-1.5-1.5S11.17 15 12 15s1.5.67 1.5 1.5S12.83 18 12 18z" />
  </svg>
  {{ message }}

  <button (click)="dismissBanner()" class="ml-auto">
    <span class="material-icons text-white hover:text-red-200 cursor-pointer text-base">X</span>
  </button>
</div>